import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { CpImage } from "@/components/company/CpImage";
import { isExternalUrl } from "@/lib/companyProfile";

/* Tombol CTA CP: internal → Link, eksternal (https/mailto/tel) → <a> tab baru. */
export function CtaButton({ cta, variant = "primary", testId }) {
  if (!cta?.label || !cta?.url) return null;
  const cls = `cp-btn cp-btn--${variant}`;
  const Icon = isExternalUrl(cta.url) ? ArrowUpRight : ArrowRight;
  if (isExternalUrl(cta.url)) {
    return <a href={cta.url} target="_blank" rel="noopener noreferrer" className={cls} data-testid={testId}>{cta.label} <Icon size={16} aria-hidden="true" /></a>;
  }
  return <Link to={cta.url} className={cls} data-testid={testId}>{cta.label} <Icon size={16} aria-hidden="true" /></Link>;
}

export function CompanyHero({ hero, brandName, catalogPath }) {
  const title = hero?.title || brandName;
  const primary = hero?.primary_cta?.label && hero?.primary_cta?.url ? hero.primary_cta : { label: "Lihat Produk", url: catalogPath };
  return (
    <section className="cp-hero" data-testid="company-hero" data-has-image={hero?.image ? "true" : "false"}>
      <div className="storefront-container cp-hero-grid">
        <div className="cp-hero-copy">
          {hero?.eyebrow ? <p className="cp-eyebrow" data-testid="company-hero-eyebrow">{hero.eyebrow}</p> : null}
          <h1 className="cp-hero-title text-4xl sm:text-5xl lg:text-6xl" data-testid="company-hero-title">{title}</h1>
          {hero?.subtitle ? <p className="cp-hero-subtitle" data-testid="company-hero-subtitle">{hero.subtitle}</p> : null}
          <div className="cp-hero-actions">
            <CtaButton cta={primary} testId="company-cta-catalog" />
            <CtaButton cta={hero?.secondary_cta} variant="ghost" testId="company-cta-secondary" />
          </div>
        </div>
        {hero?.image ? <CpImage slot="hero" src={hero.image} alt={title} priority className="cp-hero-media" testId="company-hero-image" /> : null}
      </div>
    </section>
  );
}
